if (window.__POWERED_BY_QIANKUN__) {
  /* eslint camelcase: ["error", {allow: ["__webpack_public_path__"]}] */
  /* eslint no-unused-vars: ["error", { "vars": "local" }] */
  /* global __webpack_public_path__:true */
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
